import React from "react";

export const renderScore = (match) => {
    return (
        <div className="match-score">
            {match.sets.map((set, i) => {

                if (set.game_score_1 === null || set.game_score_2 === null)
                    return

                // Base game score or +/- fallback
                let p1 = set.game_score_1 ?? (match.winner_side === 1 ? "+" : "-");
                let p2 = set.game_score_2 ?? (match.winner_side === 2 ? "+" : "-");

                // Handle tiebreak
                if (set.tiebreak_score_1 || set.tiebreak_score_2) {
                    if (set.game_score_1 < set.game_score_2) {
                        p1 += `(${set.tiebreak_score_1})`;
                    } else {
                        p2 += `(${set.tiebreak_score_2})`;
                    }
                }

                const isP2Winner = match.winner_side === 2;

                    return (
                        <span key={i} style={{ marginRight: "4px" }}>
                            {isP2Winner ? `${p2}-${p1}` : `${p1}-${p2}`}
                        </span>
                    );
            })}
        </div>
    );
};
